import { Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { Stack } from "@mui/system";

import store from "../../mobx";
import { SubsectionStack } from "./SubsectionStack";

export const Testimonials = observer(function Testimonials({
  title = "Testimonials",
  spacing = 8,
}) {
  const { isPhone } = store.mediaBreakpointStore;

  const items = [
    {
      text: "This plugin completely transformed how I work. As someone fairly new to mixing, the intuitive design helped me learn fast, and the presets sound incredible right out of the box.",
      name: "Jess, Beginner Producer",
    },
    {
      text: "I've used dozens of plugins over the years, but this one instantly stood out. The workflow is insanely fast, and it sounds amazing. It’s now part of every project I touch.",
      name: "Chris, Professional Engineer",
    },
    {
      text: "Finally, a plugin that doesn’t slow me down! It’s smartly designed, responsive, and just works. I finish mixes faster without compromising on sound.",
      name: "Alex, Music Producer",
    },
    {
      text: "As a beginner, I always struggled with getting a clean, full mix. This plugin made it so much easier to understand what’s happening — and the results sound way more pro.",
      name: "Rina, Bedroom Producer",
    },
    {
      text: "Speed and sound — that’s what this plugin nails. I get pro results in half the time, which lets me stay creative instead of getting bogged down in technical tweaks.",
      name: "Dre, Mixing Engineer",
    },
  ];

  return (
    <SubsectionStack title={title} spacing={spacing}>
      <Stack
        width="100%"
        alignItems="center"
        justifyContent="center"
        spacing={isPhone ? 4 : 6}
        sx={{ boxShadow: "0px 0px 0px 0px" }}
      >
        {items.map(({ text, name }, index) => (
          <Typography
            textAlign="center"
            key={index}
            sx={{
              fontSize: 18,
              color: "white",
              fontStyle: "italic",
            }}
          >
            {`"${text}"`}
            <br />
            <Typography
              component="span"
              sx={{
                fontSize: 18,
                textTransform: "capitalize",
                fontStyle: "normal",
              }}
            >
              - <b>{name}</b>
            </Typography>
          </Typography>
        ))}
      </Stack>
    </SubsectionStack>
  );
});
